import { skipToken } from "@reduxjs/toolkit/query";
import type { GradingId } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { ToolUsageAccuracy } from "@repo/app-types/entities/toolUsageAccuracy";
import {
  SlideoverDialog,
  SlideoverDialogContentGray,
  SlideoverDialogTitleHeader,
} from "@repo/ui/Slideover/slideoverDialog";
import type { FC } from "react";
import { usePlaybookGradingQuery } from "../../api/entities/performancePlaybook.js";
import { useBasicTeammateQuery } from "../../api/entities/teammate.js";
import { ToolUsageAccuracyCallSlideoverDialogContent } from "./toolUsageAccuracyCallSlideoverDialogContent.js";

export interface ToolUsageAccuracyCallSlideoverDialogContainerProps {
  gradingId: GradingId;
  toolId: string;
  toolName: string;
}

export const ToolUsageAccuracyCallSlideoverDialogContainer: FC<
  ToolUsageAccuracyCallSlideoverDialogContainerProps
> = (props) => {
  const { gradingId, toolId, toolName } = props;

  const { data: grading, isLoading } = usePlaybookGradingQuery({ gradingId });
  const { data: teammate } = useBasicTeammateQuery(
    grading?.teammate_id ?? skipToken,
  );

  // Get tool accuracy from the fetched grading
  const toolAccuracy: ToolUsageAccuracy | undefined =
    grading?.tool_usage_accuracy?.tools[toolId];

  return (
    <SlideoverDialog label="Tool accuracy finding">
      <SlideoverDialogTitleHeader isLoading={!grading && isLoading}>
        Tool accuracy finding
      </SlideoverDialogTitleHeader>
      <SlideoverDialogContentGray>
        {grading ? (
          <ToolUsageAccuracyCallSlideoverDialogContent
            gradingId={gradingId}
            recordings={grading.recordings}
            teammateType={teammate?.type}
            toolAccuracy={toolAccuracy}
            toolId={toolId}
            toolName={toolName}
          />
        ) : null}
      </SlideoverDialogContentGray>
    </SlideoverDialog>
  );
};
